import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnalyticsManager from '../../../../app/analytics';
import { combineClassNames, generateUniqueId, sortArrayByKey } from '../../../../app/functions';
import * as routes from '../../../../constants/routes';
import MegaMenuItem from '../mega-menu-item';
import MegaMenuAction from '../mega-menu-action';
import MegaMenuCategory from '../mega-menu-category';
import './index.scss';

const MegaMenu = React.forwardRef((props, ref) => {
    const [items, setItems] = useState([]);

    const {
        megaMenu,
        megaMenuMaxCategories,
        Translations: translations,
    } = useSelector((store) => store.config);
    const megaMenuId = useSelector((store) => store.state.megaMenuId);
    
    const { shopping_categories, smart_consuming, actions } = megaMenu;

    const handleAllBenefitsClick = () => AnalyticsManager.logMenuItemPress(translations['mega_menu_all_benefits']);

    useEffect(() => {
        let itemsArr = [];

        switch (megaMenuId) {
            // Shopping Categories
            case 0:
                const categories = sortArrayByKey(Object.values(shopping_categories));
                const min = Math.min(megaMenuMaxCategories, categories.length);

                for (let i = 0; i < min; i++) {
                    itemsArr.push(
                        <MegaMenuCategory
                            key={`${categories[i].title}_${generateUniqueId(8)}`}
                            id={categories[i].id}
                            data={categories[i]}
                            text={categories[i].title}
                            icon={categories[i].appImagePath}
                            subCats={categories[i].subCatsArr}
                        />
                    );
                }
                break;

            // Smart Consuming
            case 1:
                sortArrayByKey(Object.values(smart_consuming)).forEach((item) => {
                    itemsArr.push(
                        <MegaMenuItem
                            key={item.id + item.title}
                            text={item.title}
                            icon={item.icon}
                            link={item.link}
                            iconClassName="smart-consumption-icon"
                            direction="ltr"
                        />
                    );
                });
                break;

            // Actions
            case 2:
                sortArrayByKey(Object.values(actions)).forEach((item) => {
                    itemsArr.push(
                        <MegaMenuAction
                            key={item.id + item.title}
                            text={item.title}
                            image={item.icon}
                            link={item.link}
                        />
                    );
                });
                break;
        }

        setItems(itemsArr);
    }, [megaMenuId]);

    return (
        <div className="mega-menu-wrapper" ref={ref}>
            {megaMenuId !== null && (
                <div className="mega-menu-container">
                    <div className={combineClassNames(
                        'mega-menu',
                        megaMenuId === 0 && 'categories-grid', // Shopping Categories
                        megaMenuId === 2 && 'actions-flex', // Actions
                    )}>
                        {items}

                        {megaMenuId === 0 && (
                            <NavLink to={routes.benefits} className="all-benefits" onClick={handleAllBenefitsClick}>
                                {translations['mega_menu_all_benefits']}
                            </NavLink>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
});

export default MegaMenu;
